import { BORDER_RADIUS } from "@/constants";
import { Box, useTheme } from "@mui/material";
import { ReactElement } from "react";
import { Wave } from "react-css-spinners";

export default function CustomOverlapLoader({
  isLoading,
  children,
  width = "auto",
  height = "auto",
}: CustomOverlapLoaderProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width,
        height,
        position: "relative",
      }}
    >
      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#fff",
              zIndex: 1,
              width: "100%",
              height: "100%",
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: "0.5",
              borderRadius: BORDER_RADIUS,
            }}
          />
          <Wave
            color={theme.palette.primary.main}
            size={60}
            style={{ zIndex: 2 }}
          />
        </Box>
      )}
      {children}
    </Box>
  );
}

interface CustomOverlapLoaderProps {
  isLoading: boolean;
  children: ReactElement;
  width?: string | number;
  height?: string | number;
}
